import AbstractApiReducer from "services/cores/abstractApiReducer";
import ParkedCarsActionTypes from "./types";

const instance = new AbstractApiReducer(ParkedCarsActionTypes, {
  list: {
    orders: {},
  },
});
export default instance.reducer;
